/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Leads_SubtitleInputs */

const cs_leads_subtitle = /** @type {(inputs: Leads_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Příchozí poptávky a konverze.`)
};

const en_leads_subtitle = /** @type {(inputs: Leads_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inbound inquiries and conversion.`)
};

/**
* | output |
* | --- |
* | "Inbound inquiries and conversion." |
*
* @param {Leads_SubtitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const leads_subtitle = /** @type {((inputs?: Leads_SubtitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leads_SubtitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_leads_subtitle(inputs)
	return cs_leads_subtitle(inputs)
});